import { Step1, Step2, Step3 } from './JiraConnectSteps';
import useJiraSetupStates from './hooks/useJiraSetupStates';
import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import { Flex, Margin } from 'components/base/layout-components';
import _ from 'lodash';
import styled from 'styled-components';

const ElementBackground = styled(Flex)`
  margin-bottom: 1px;
  padding-top: ${SPACES['x-medium']};
  ${props =>
    props.color
      ? `background-color: ${getColor(props.color)}`
      : `background-color: ${getColor('white')}`};
`;

const JiraSetup = ({
  toggleModal,
  account,
  configuration,
  toggleSnackBar,
  getSensorAuthorizations,
  selectedManagementTool
}) => {
  const jiraSetupStates = useJiraSetupStates();
  const { nat_gateway_ips } = configuration;
  const { customer_key, shared_secret, rsa_public_key } =
    jiraSetupStates.authKeys;

  if (!jiraSetupStates.state) {
    return null;
  }

  return (
    <>
      {!jiraSetupStates.finish && (
        <ElementBackground>
          <Step1
            value={jiraSetupStates.baseJiraUrl}
            onChange={jiraSetupStates.onUrlChange}
            onContinue={jiraSetupStates.onStep1Finish}
            allowContinue={jiraSetupStates.step1Enabled}
            allowInput={!jiraSetupStates.step2Enabled}
            errorMessage={jiraSetupStates.step1Error}
            version={_.get(jiraSetupStates.authKeys, 'version')}
            nat_gateway_ips={nat_gateway_ips}
          />
        </ElementBackground>
      )}
      {jiraSetupStates.step2Enabled && !jiraSetupStates.finish && (
        <ElementBackground>
          <Step2
            disabled={false}
            onContinue={jiraSetupStates.onStep2Finish}
            jiraBaseURL={jiraSetupStates.baseJiraUrl}
            onFinish={jiraSetupStates.onStep3Finish}
            consumerKey={customer_key}
            sharedSecret={shared_secret}
            publicKey={rsa_public_key}
            finish={jiraSetupStates.finish}
            separator={<Margin margin='small' />}
          />
        </ElementBackground>
      )}
      {jiraSetupStates.finish && (
        <ElementBackground>
          <Step3 onFinish={jiraSetupStates.onStep3Finish} />
        </ElementBackground>
      )}
    </>
  );
};

export default JiraSetup;
